import { memo } from 'react';

/**
 * Error Display Component
 * PERFORMANCE OPTIMIZED: Uses React.memo to prevent unnecessary re-renders
 */
const ErrorMessage = memo(function ErrorMessage({ error, onRetry, onBack, residentId }) {
  const errorDetails = error?.response?.data?.detail || error?.message || "Unknown error occurred";
  const isNotFound = error?.status === 404 || error?.isNotFound || errorDetails.includes('404') || errorDetails.includes('not found');
  
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "400px",
      gap: 20,
      padding: 40,
      textAlign: "center"
    }}>
      {isNotFound ? (
        // 404 Not Found Icon
        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#FFA500" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 8v4"/>
          <circle cx="12" cy="16" r="0.5" fill="#FFA500"/>
        </svg>
      ) : (
        // Generic Error Icon
        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#ff4444" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <line x1="15" y1="9" x2="9" y2="15"/>
          <line x1="9" y1="9" x2="15" y2="15"/>
        </svg>
      )}
      
      <div>
        <h2 style={{ color: isNotFound ? "#FFA500" : "#ff4444", marginBottom: 10, fontSize: 24 }}>
          {isNotFound ? "Data Not Found" : "Error Loading Data"}
        </h2>
        <p style={{ color: "#ffffff", opacity: 0.7, fontSize: 14, maxWidth: 500, marginBottom: 10 }}>
          {isNotFound 
            ? "The requested data could not be found. It may have been deleted or the ID is incorrect."
            : errorDetails
          }
        </p>
        {residentId && (
          <p style={{ color: "#ffffff", opacity: 0.5, fontSize: 12 }}>
            Resident ID: {residentId}
          </p>
        )}
      </div>
      
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", justifyContent: "center" }}>
        {isNotFound && onBack && (
          <button
            onClick={onBack}
            style={{
              padding: "12px 30px",
              fontSize: 16,
              fontWeight: 600,
              color: "#ffffff",
              background: "linear-gradient(135deg, #042558 0%, #1e3a8a 100%)",
              border: "2px solid #FFFFFF",
              borderRadius: 8,
              cursor: "pointer",
              transition: "all 0.2s",
              display: "flex",
              alignItems: "center",
              gap: 8
            }}
            onMouseOver={e => {
              e.target.style.transform = "scale(1.05)";
              e.target.style.background = "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)";
            }}
            onMouseOut={e => {
              e.target.style.transform = "scale(1)";
              e.target.style.background = "linear-gradient(135deg, #042558 0%, #1e3a8a 100%)";
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            Go Back
          </button>
        )}
        
        {onRetry && !isNotFound && (
          <button
            onClick={onRetry}
            style={{
              padding: "12px 30px",
              fontSize: 16,
              fontWeight: 600,
              color: "#ffffff",
              background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              transition: "transform 0.2s"
            }}
            onMouseOver={e => e.target.style.transform = "scale(1.05)"}
            onMouseOut={e => e.target.style.transform = "scale(1)"}
          >
            Retry
          </button>
        )}
      </div>
      
            {!isNotFound && (
        <p style={{ color: "#ffffff", opacity: 0.5, fontSize: 12, marginTop: 20 }}>
          If the problem persists, please contact your system administrator.
        </p>
      )}
    </div>
  );
});

export default ErrorMessage;
